import { useEffect, useState } from 'react';
import { useAuth } from './AuthProvider';
import Home from './components/pages/Home';
import RunReportsSidebar from './components/layout/RunReportsSidebar';
import { Box, CircularProgress } from '@mui/material';

export default function AdminRoute({ children }) {
  const { user, isLoading, getAccessToken } = useAuth();
  const token = getAccessToken();

  const [adminStatus, setAdminStatus] = useState('checking'); // 'checking' | 'allowed' | 'denied'

  useEffect(() => {
    if (!user) return;

    async function checkAdmin() {
      try {
        const res = await fetch(`${process.env.REACT_APP_NODE_URL}/admin/check-admin`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getAccessToken()}`,
          },
          body: JSON.stringify({ email: user.Email }),
        });
        const data = await res.json();
        if (data.isAdmin === true) {
          setAdminStatus('allowed');
        } else {
          const admin_emails = ['clay@vestmap.com', 'clay@authenticaudience.co'];
          setAdminStatus(admin_emails.includes(user?.Email?.toLowerCase()) ? 'allowed' : 'denied');
        }
      } catch {
        setAdminStatus('denied');
      }
    }

    checkAdmin();
  }, [user]);

  if (isLoading && !token) return null;

  // Not logged in — show landing page
  if (!user && !token) return <Home />;

  // Waiting on admin check
  if (adminStatus === 'checking') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Not an admin — redirect to dashboard
  if (adminStatus === 'denied') {
    return <Home />;
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '100%', sm: '22% 78%', md: '18% 82%' },
        width: '100%',
        height: '100vh',
      }}
    >
      <RunReportsSidebar />
      <Box sx={{ height: '100vh', overflow: 'scroll' }}>
        {children}
      </Box>
    </Box>
  );
}
